import axios from "axios";
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppProvider";
import CBSGCharLoader from "../../Page/CBSGCharLoader";
import { StickyScroll } from "../ui/sticky-scroll-reveal";

const Time = () => {

  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true); // Added loading state
  const { uri } = useContext(AppContext);

  useEffect(() => {
    axios.get(`${uri}year-ranges/`)
      .then((response) => {
        // console.log(response.data);
        setContent(response.data); // Assuming response.data is the content
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); // Set loading to false if an error occurs
      });

  }, []);

  if (loading) return <CBSGCharLoader />; // Display loader while data is loading

  

  return (
    <div className="mt-5 ">
      <StickyScroll content={content} />
    </div>
  );
};

export default Time;
Time.propTypes = {
  uri: PropTypes.string.isRequired,
};